<template>
  <bc-select v-model='suppliers' :options='optionsMerged' @update:search-value='search' :on-select-option='selectOption' :search-in-options="['label']">
    <template #noresults='{ searchInput }'>
      <li class='dropdown-item px-4 py-2 text-red-500'>
        <template v-if="searchInput.value != ''">
          {{ $t('Supplier with name "%value%" not found', { value: searchInput.value }) }}
        </template>
        <template v-if='allowNew'>
          {{ $t('Start typing to search existing suppliers or enter name to add new supplier') }}
        </template>
        <template v-else>
          {{ $t('Start typing to search existing suppliers') }}
        </template>
      </li>
    </template>
    <template #option='slotProps'>
      <li
        role='option'
        class='cursor-default select-none relative py-2 pl-4 pr-4 truncate d-flex'
        :class="{
          'text-white bg-bc-blue': slotProps.highlighted,
          'text-gray-800': !slotProps.highlighted
        }"
        @mouseenter='slotProps.handleMouseEnter(slotProps.option)'
        @click.stop='slotProps.selectOption(slotProps.option)'
      >
        {{ slotProps.option.label }}
      </li>
    </template>
  </bc-select>
</template>
<script>
import { SupplierApi } from '../../test-api/index.ts'
import axios from 'axios'
import find from 'lodash/find'
import findIndex from 'lodash/findIndex'

const supplierApi = new SupplierApi({}, '/api/v2')
const CancelToken = axios.CancelToken

let cancelationToken

export default {
  emits: ['update:modelValue'],
  props: {
    id: String,
    modelValue: [Array, String, Number],
    enabled: Boolean,
    multiple: Boolean,
    allowNew: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: [],
      q: null,
      tempEmail: null,
      addedSuppliers: [],
      firstLoadDone: false
    }
  },
  computed: {
    suppliers: {
      get() {
        return this.modelValue
      },
      set(newVal) {
        this.$emit('update:modelValue', newVal)
      }
    },
    controlItems() {
      return this.$controls[this.id].items
    },
    optionsMerged() {
      let mergedItems = [...this.options, ...this.addedSuppliers, ...this.controlItems]
      if (this.tempEmail) {
        mergedItems.push({
          id: this.tempEmail,
          label: this.tempEmail
        })
      }

      return mergedItems
    }
  },
  methods: {
    search(val) {
      if (this.allowNew && !find(this.optionsMerged, ['id', val])) {
        this.tempEmail = val
      }

      if (val !== '') {
        this.q = val
      }
    },
    selectOption(option, parentSelectOption) {
      if (option.id === this.tempEmail) {
        this.addedSuppliers.push({
          id: this.tempEmail,
          label: this.tempEmail
        })

        this.tempEmail = null
      } else if (!find(this.addedSuppliers, ['id', option.id])) {
        this.addedSuppliers.push(option)
      }

      const foundInOptions = findIndex(this.options, ['id', option.id])
      if (foundInOptions !== -1) {
        this.options.splice(foundInOptions, 1)
      }

      parentSelectOption(option)
      /*
      // check if option is selected in recipients
      if (!this.recipients.includes(option.id)) {

      }

      // if is selected in recipients -> remove it
      */
    },
    async loadSuppliers(val) {
      if (cancelationToken !== undefined) {
        cancelationToken.cancel()
        cancelationToken = undefined
      }

      try {
        cancelationToken = CancelToken.source()
        const supplierResponse = await supplierApi.supplierList(val || undefined, undefined, undefined, {
          cancelToken: cancelationToken.token
        })
        this.options = []
        supplierResponse.data.forEach((supplier) => {
          if (!find(this.addedSuppliers, ['id', supplier.id]) && !find(this.controlItems, ['id', supplier.id])) {
            supplier.label = supplier.name
            this.options.push(supplier)
          }
        })
      } catch (e) {
        // noop
      }
    }
  },
  watch: {
    q: {
      handler: function(val) {
        if (this.enabled) {
          this.loadSuppliers(val)
        }
      }
    }
  }
}
</script>